export const getAuthErrorMessage = (
  error,
  defaultMsg = "Unable to sign in right now. Please try again.",
) => {
  const regex = /Firebase:\s(.*?)\s\(auth\/[^)]+\)/
  const extractedMessage = error?.message?.match(regex)?.[1]

  const fallbackMessageByCode = {
    "auth/user-not-found": "User not found",
    "auth/wrong-password": "Invalid password",
    "auth/invalid-email": "Invalid email address",
    "auth/invalid-verification-code": "Invalid verification code",
    "auth/user-disabled": "This account has been disabled",
    "auth/too-many-requests":
      "Too many attempts. Please try again in a few minutes",
    "auth/network-request-failed":
      "Network error. Check your connection and try again",
    "auth/internal-error": "An internal error occurred. Please try again",
    "auth/code-expired": "Verification code expired. Please try again.",
  }

  const mappedMessage = fallbackMessageByCode[error?.code]
  if (mappedMessage) return mappedMessage

  // Ignore Firebase's generic "Error" extraction and prefer a clearer default.
  if (extractedMessage && extractedMessage !== "Error") {
    return extractedMessage
  }

  return defaultMsg
}